<section class="container-fluid p-2">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div
        class="pb-3 mb-3 d-flex flex-lg-row flex-column gap-2 align-items-lg-center justify-content-between">
        <div>
          <h4 class="mb-0 fw-600 title-color">Orders</h4>
        </div>
        <div class="d-flex align-items-center">
          <!-- TODO -->
<!--          <a class="me-5 text-body">-->
<!--            <img src="assets/svg/export.svg" class="me-2">-->
<!--            Export-->
<!--          </a>-->
        </div>
      </div>
    </div>
  </div>
  <div class="pb-2 d-flex flex-lg-row flex-column align-items-lg-center justify-content-between">
    <div class="col-12 col-lg-6 pe-1">
      <div class="search-bar">
        <mat-icon>search</mat-icon>
        <input type="search" #searchInput (input)="onSearch(searchInput.value)"
               (keyup.enter)="onEnterKeyPressed(searchInput.value)"
               placeholder="Search user by full name"/>
      </div>
    </div>
    <div class="col-6 col-lg-6 ">
      <div class="search-bar">
        <select id="status" class="form-select no-border cursor-pointer"
                [(ngModel)]="selectedStatus"
                (change)="filterOrdersByStatus()" data-choices="">
          <option selected value="">All Statuses</option>
          @for (status of OrderStatus | keyvalue; track status) {
            <option [ngValue]="status.key"> {{ status.value }}</option>
          }
        </select>
      </div>
    </div>
  </div>
  <div class="row mt-4 ">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card rounded-3 br-30px">
        <div class="float-start p-3 pb-0"><span>Orders/{{ totalOrdersCount }}</span>
          <mat-divider class="mt-2"></mat-divider>
        </div>
        <div class="p-3">
          <div class="tab-content" id="tabContent">
            <div class="tab-pane fade show active" id="all-orders" role="tabpanel" aria-labelledby="all-orders-tab">
              <div class="table-responsive">
                <table class="table mb-0 text-nowrap table-hover table-centered table-with-checkbox">
                  <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Customer</th>
                    <th>Date</th>
                    <th>Items</th>
                    <th>Promocode</th>
                    <th>Total</th>
                    <th>Order Status</th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (order of orders; track $index) {
                      <tr [routerLink]="['/admin/page/shop/orders/detail/'+order.id]" class="cursor-pointer">
                        <td>
                          <span class="fw-semibold">
                            {{ (currentPage * pageSize) + $index  + 1 }}
                          </span>
                        </td>
                        <td>{{ order.userInfo?.name + ' ' + order.userInfo.surname }}</td>
                        <td>{{ order.createdAt | date:'dd MMM, yyyy hh:mm a':'UTC+4' }}</td>
                        <td>{{ order.itemsCount }}</td>
                        <td>{{ order.promoCode || '—' }}</td>
                        <td>{{ order.totalAmount | number:'1.1-1'}}</td>
                        <td>
                          <select class="form-control cursor-pointer status" style="appearance:auto"
                                  [(ngModel)]="order.orderStatus"
                                  (change)="updateOrderStatus(order)"
                                  [ngClass]="{
            'select-paid': order.orderStatus === OrderStatus.PAID,
            'select-canceled': order.orderStatus === OrderStatus.CANCELLED,
            'select-in-delivery': order.orderStatus === OrderStatus.IN_DELIVERY,
            'select-delivered': order.orderStatus === OrderStatus.DELIVERED,
            'select-unpaid': order.orderStatus === OrderStatus.UNPAID,
            'select-new': order.orderStatus === OrderStatus.NEW,
          }" (click)="$event.stopPropagation()">
                            <option [value]="order.orderStatus" disabled>{{ getPastValue(order.orderStatus) }}
                            </option>
                            @for (orderStatus of getStatusOptions(order); track orderStatus.value) {
                              <option [value]="orderStatus.value"
                              >{{ orderStatus.viewValue }}
                              </option>
                            }
                          </select></td>
                      </tr>
                    }
                    @if (orders.length == 0) {
                      <tr>
                        <td class="text-muted mt-1 no-border no-hover" >No Data to display</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <a (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 0">&laquo;</a>
          <a *ngFor="let page of getPageNumbers()"
             (click)="goToPage(page - 1)"
             [class.active]="currentPage === (page - 1)">
            {{ page }}
          </a>
          <a (click)="goToPage(currentPage + 1)" [class.disabled]="currentPage === totalPageCount - 1">&raquo;</a>
        </div>
      </div>
    </div>
  </div>
</section>
